// extracted by mini-css-extract-plugin
export default {"error":"slyles_error__ZKO+t","spin":"slyles_spin__AG0Qs"};